export default `
  subscription OnBoundedContextStatusChanged($workflowId: ID!, $boundedContextId: ID!) {
    onBoundedContextStatusChanged(workflowId: $workflowId, boundedContextId: $boundedContextId) {
      id
      boundedContextId
      workflowId
      name
      codeGenerationStatus
      codeGenerationError
      generationProgress {
        id
        text
        completed
        failed
      }
      failedItems {
        type
        name
        domainIds
        error
      }
    }
  }
`
